import { Navigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { MockBanner } from "../components/MockBanner";
import { LoadingState } from "../components/ui";

export function LoginPage() {
  const auth = useAuth();
  if (auth.status === "signed_in") return <Navigate to="/" replace />;
  return (
    <>
      <MockBanner />
      <main className="login">
        <div className="login-card">
          <span className="eyebrow">AVA REMOTA</span>
          <h1>Portal do Condomínio</h1>
          {auth.status === "loading" ? (
            <LoadingState label="Concluindo autenticação…" />
          ) : (
            <>
              <p>
                {auth.mode === "mock"
                  ? "Ambiente simulado para desenvolvimento: nenhuma credencial real é usada."
                  : "Entre com sua conta cadastrada. Você será redirecionado para a página de login da Microsoft — o portal nunca vê nem armazena sua senha."}
              </p>
              {auth.error && (
                <p className="error" role="alert">{auth.error}</p>
              )}
              <button type="button" onClick={auth.signIn}>
                {auth.mode === "mock" ? "Entrar (ambiente simulado)" : "Entrar com Microsoft"}
              </button>
            </>
          )}
        </div>
      </main>
    </>
  );
}
